module.exports = __webpack_public_path__ + "static/media/coracao-garante.5fc0f0b3.svg";